(function () {
  function startCountdown(root) {
    var dEl = root.querySelector('[data-countdown-days]');
    var hEl = root.querySelector('[data-countdown-hours]');
    var mEl = root.querySelector('[data-countdown-minutes]');
    var sEl = root.querySelector('[data-countdown-seconds]');
    if (!hEl || !mEl || !sEl) return;

    var endAttr = (root.dataset.countdownEnd || '').trim();
    var endTime;
    if (endAttr) {
      // soporta "2026-07-19" o "2026-07-19T23:59:59"
      if (endAttr.indexOf('T') === -1 && endAttr.length === 10) {
        endAttr = endAttr + 'T23:59:59';
      }
      var parsed = new Date(endAttr).getTime();
      if (!isNaN(parsed)) {
        endTime = parsed;
      }
    }
    if (!endTime) {
      var today = new Date();
      today.setHours(23, 59, 59, 999);
      endTime = today.getTime();
    }

    function pad(n){ return String(n).padStart(2,'0'); }

    function tick() {
      var diff = endTime - Date.now();
      if (diff <= 0) {
        if (dEl) dEl.textContent = '00';
        hEl.textContent = mEl.textContent = sEl.textContent = '00';
        return;
      }
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      if (dEl) dEl.textContent = pad(d);
      hEl.textContent = pad(h);
      mEl.textContent = pad(m);
      sEl.textContent = pad(s);
    }
    tick();
    setInterval(tick, 1000);
  }

  function init() {
    // recorre TODOS los countdowns de la página
    document.querySelectorAll('[data-countdown]').forEach(startCountdown);
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
